import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=4d206890&scoped=true"
import script from "./CalendarEvent.vue?vue&type=script&lang=js"
export * from "./CalendarEvent.vue?vue&type=script&lang=js"
import style0 from "./CalendarEvent.vue?vue&type=style&index=0&id=4d206890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d206890",
  null
  
)

export default component.exports